// src/pages/fleet/gpsProvider.ts — one spelling for each GPS company.
//
// The vehicle master stores a single capitalised word per provider ('Wheelseye',
// 'Blackbuck', 'Margogps') because that is what the import sheets and the admin
// dropdown use. None of the three companies writes itself that way, and a name
// that does not match their portal is one more thing to second-guess when a feed
// looks wrong. So every screen renders the name through here rather than printing
// the stored value, and a provider we do not recognise is shown as stored instead
// of being hidden.
const PROVIDER_NAME: Record<string, string> = {
  wheelseye: 'WheelsEye',
  blackbuck: 'BlackBuck',
  margogps: 'margoGPS',
};

export const providerName = (v: string | null | undefined): string | null =>
  (v ? PROVIDER_NAME[v.toLowerCase()] || v : null);
